export default __webpack_public_path__ + "9614f07381cd87f91397aa62d753d425.png";